import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  IconButton,
  HeadingSection,
  RouteWrapper,
  Statistics,
  Section,
} from '../../components';

interface Props {
  goBack: () => void;
}

class Route extends React.Component<Props> {
  render() {
    return (
      <RouteWrapper requireAuth title="Statistics">
        <HeadingSection
          title="Statistics"
          controls={[
            <IconButton
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.goBack();
              }}
              key="return"
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <Statistics />
        </Section>
      </RouteWrapper>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(goBack()),
});

export default connect(undefined, mapDispatchToProps)(Route);
